import { Injectable, Inject, Injector } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, of } from 'rxjs';
import { ConnectionService } from '../../../services/connection/connection.service';
import { map } from 'rxjs/operators';
import { ShopSettingsService } from './shop-settings.service';
import { Theme } from '../models/theme';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AssetsService } from '../../vu/services/assets.service';
import { LoggerService } from '../../../services/logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private theme = new Theme();
  private foundBackgroundAssetUrl: string;
  private internalLog: LoggerService;
  readonly AllCategoryId = '1';

  constructor(
    private shopSettingsService: ShopSettingsService,
    private connectionService: ConnectionService,
    private router: Router,
    private assetsService: AssetsService,
    private injector: Injector,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const urlAfterRedirects = event.urlAfterRedirects || event.url;
        this.foundBackgroundAssetUrl = this.theme.getBackgroundAssetUrl(urlAfterRedirects);
        this.document.body.style.background = this.backgroundImageCss;
        this.document.body.style.backgroundAttachment = 'fixed';
        this.document.body.style.backgroundSize = 'cover';
        this.document.body.style.backgroundColor = 'unset';
      }
    });
  }

  initialize(): Observable<boolean> {
    if (!this.shopSettingsService.shopSettings.themeAssetsUrl) {
      return of(false);
    }

    return this.connectionService.sendGetRequest(this.shopSettingsService.shopSettings.themeAssetsUrl)
      .pipe(map(
        x => {
          if (x) {
            this.theme.initialize(x);
            return true;
          }

          return false;
        }
      ));
  }

  get backgroundImageCss(): string {
    if (!this.foundBackgroundAssetUrl) {
      return 'unset';
    }

    return 'url("' + this.foundBackgroundAssetUrl + '")';
  }

  get baseUrl(): string {
    return 'static';
  }

  get themeBaseUrl(): string {
    if (environment.theme) {
      return `${this.baseUrl}/theme/${environment.theme}`;
    }
    return this.baseUrl;
  }

  setBackgroundCategoryImage(categoryId) {
    this.log.info(`setBackgroundCategoryImage: ${categoryId}`);
    this.setBackgroundImage(this.assetsService.getCategoryImageUrl(categoryId));
  }

  setBackgroundImageById(imageId) {
    this.log.info(`setBackgroundImageById: ${imageId}`);
    this.setBackgroundImage(this.assetsService.getImageUrlById(imageId));
  }

  setBackgroundImage(backgroundUrl: string) {
    if (backgroundUrl == null || backgroundUrl === 'none') {
      document.body.style.backgroundImage = 'none';
    } else {
      document.body.style.backgroundImage = 'url(\'' + backgroundUrl + '\')';
    }
  }

  set backgroundColor(color: string) {
    document.body.style.backgroundColor = color;
  }

  get backgroundColor() {
    return document.body.style.backgroundColor;
  }

  get log() {
    if (this.internalLog == null) {
      this.internalLog = this.injector.get(LoggerService);
    }
    return this.internalLog;
  }

  get all_category_id(): string {
    return this.AllCategoryId;
  }
}
